import {
  Directive,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { AuthenticationService } from '@core/services/authentication/authentication.service';

@Directive({
  selector: '[appHasPlatformAccess]',
  standalone: true,
})
export class HasPlatformAccessDirective implements OnInit {
  constructor(
    private container: ViewContainerRef,
    private template: TemplateRef<string>,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit(): void {
    this.checkAccess();
  }

  checkAccess(): void {
    const isSuperAdmin = this.authenticationService.isSuperAdmin();
    if (isSuperAdmin) {
      this.container.createEmbeddedView(this.template);
    } else {
      this.container.clear();
    }
  }
}
